import { useFormState, useMultistepState } from 'informed';

import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiLinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';

import { FieldMap, FieldsNotQualifiedForProgress } from '../model/FieldMap';
import INITIAL_FORM_STATE, {
  addressInformation,
  AddressInformationStep,
  basicInformation,
  BasicInformationStep,
  EmployeeInformationStep,
  financeInformation,
  FinanceInformationStep,
  personalInformation,
  PersonalInformationStep,
  employeeInformation,
} from '../model/formState';

const LinearProgress = styled(MuiLinearProgress, { name: 'linearProgress' })(({ theme }) => ({
  height: '7px',
  borderRadius: '4px',
  backgroundColor: '#F1F5F8',
  mb: '.8rem',

  [theme.breakpoints.up('sm')]: {
    mb: 0,
  },

  [`.${linearProgressClasses.bar1Buffer}`]: {
    backgroundColor: '#1F2E42',
  },
  [`.${linearProgressClasses.bar2Buffer}`]: {
    backgroundColor: '#1F2E42',
  },
  [`.${linearProgressClasses.dashed}`]: {
    backgroundImage: 'none',
  },
}));

const progressQualifiedFields = Object.values(FieldMap).filter(
  (name) => !FieldsNotQualifiedForProgress.includes(name),
);
const ratio = (numerator) =>
  Number(((numerator.length / progressQualifiedFields.length) * 100).toFixed(0));
const steps = Object.keys(INITIAL_FORM_STATE);

const { beforeAgreements } = basicInformation as BasicInformationStep;
const initialFlatStepsState = {
  basicInformation: {
    ...beforeAgreements,
  },
  personalInformation,
  addressInformation,
  financeInformation,
  employeeInformation,
};

const ProgressWrapper = () => {
  const { values } = useFormState();
  const { current } = useMultistepState();

  const bufferQualifiedStepsKeys = steps.slice(0, steps.indexOf(current) + 1);
  bufferQualifiedStepsKeys.flatMap((stepKey) => Object.keys(initialFlatStepsState)[stepKey]);

  const flatTouchedStepsFields = bufferQualifiedStepsKeys;

  const { beforeAgreements } = (values.basicInformation || {}) as BasicInformationStep;
  const flatFormState = values
    ? {
        ...beforeAgreements,
        ...(values.personalInformation as PersonalInformationStep),
        ...(values.addressInformation as AddressInformationStep),
        ...(values.financeInformation as FinanceInformationStep),
        ...(values.employeeInformation as EmployeeInformationStep),
      }
    : {};

  const filled = progressQualifiedFields.filter(
    (fieldName) => flatFormState[fieldName] /*&& !errors[fieldName]*/,
  );
  const progress = ratio(filled);
  const buffer = ratio(flatTouchedStepsFields);

  return (
    <Box
      sx={{
        width: '100%',
        padding: '6.2rem 5.6rem',
      }}
    >
      <LinearProgress variant="buffer" value={progress} valueBuffer={buffer} />
    </Box>
  );
};

export default ProgressWrapper;
